import React from 'react';
import Hero from '../components/Hero';
import Marquee from '../components/Marquee';
import Services from '../components/Services';
import About from '../components/About';
import Approach from '../components/Approach';
import CTA from '../components/CTA';
import Contact from '../components/Contact';

export default function Home() {
  return (
    <>
      <Hero />
      <Marquee />
      <Services />
      <About />
      <Approach />
      <CTA />
      <Contact />
    </>
  );
}
